import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Toast, Toptips, ActionSheet, Dialog} from 'react-weui';
//import {InvitationCard} from './InvitationCard';
import {browserHistory} from 'react-router';


import '../styles/Page.css';


class Page extends Component {
    constructor(props) {
        super(props)

        this.state = {
            showOperateMenu: false,
            showToast: false,
            toastText: 'Done',
            toastIcon: 'success-no-circle',
            showTips: false,
            tipsType: 'warn',
            tipsText: 'Warn',
            operateMenus: [],
            operatingItem: null,
            alert: {
                show: false,
                text: null,
                title: null,
                buttons: []
            },
            confirm: {
                show: false,
                text: null,
                title: null,
                buttons: []
            }
        }

        if (props.parent) {
            props.parent.page = this;
        }
    }

    getChildContext() {
        return {page: this};
    }

    isPayPath(path) {
        if (path === '/')
            return true
        if (path.indexOf('/lecture/') === 0)
            return true
        if (path.indexOf('/classroom/') === 0)
            return true
        if (path.indexOf('/channel/') === 0)
            return true
        if (path.indexOf('/liveroom/') === 0)
            return true
        return false
    }

    componentWillMount() {
        /* 解决iOS上的支付问题 */
        if (window.systemType === 'ios') {
            const routerLocation = browserHistory.getCurrentLocation()
            const currentPath = routerLocation.pathname
            const landingPath = window.landingPath
            if (currentPath !== landingPath) {
                if (this.isPayPath(currentPath) && !this.isPayPath(landingPath)) {
                    window.location = routerLocation.pathname + routerLocation.search
                    return
                }
            }
        }

        /* 安卓手机的url会变化，需要重新生成签名 */
        if(window.systemType === 'android'){
            this.props.dispatch({
                type: 'WECHAT_INIT'
            });
        }

        this.props.dispatch({
            type: 'PAGE_INIT'
        });
    }

    clearTimeouts() {
        this.toastTimer && clearTimeout(this.toastTimer);
        this.tipsTimer && clearTimeout(this.tipsTimer);
    }

    componentWillUnmount() {
        this.clearTimeouts();
    }

    showLoading(text){
        this.showToast(text || '请稍后', 'loading')
    }

    hideLoading(){
        this.hideToast()
    }

    showError(text, buttonLabel, clickUrl){
        this.props.dispatch({
            type: 'ERROR_SHOW',
            payload: {
                tips: text,
                btn: buttonLabel,
                href: clickUrl
            }
        })
    }

    showToast(text, icon = 'success-no-circle', isAutoClose = true, time = 1000) {
        this.setState({showToast: true, toastText: text, toastIcon: icon});

        this.clearTimeouts();
        if (isAutoClose) {
            this.toastTimer = setTimeout(() => {
                this.setState({showToast: false});
            }, time);
        }
    }

    hideToast() {
        this.setState({showToast: false});
    }

    showTips(text, type) {
        // type: default, warn, info, primary
        this.setState({showTips: true, tipsText: text, tipsType: type || 'default'});

        this.clearTimeouts();
        this.tipsTimer = setTimeout(() => {
            this.setState({showTips: false});
        }, 2000);
    }
    showRefundAlert(text, callback, title) {
        this.setState({
            alert: {
                text: text,
                title: title,
                show: true,
                buttons: [{
                    label: '关闭',
                    type:'default',
                    onClick: e => {
                        this.setState({alert: {show: false}});
                        callback && callback()
                    }
                }]
            }
        })
    }
    showAlert(text, callback, title) {
        this.setState({
            alert: {
                text: text,
                title: title,
                show: true,
                buttons: [{
                    label: '知道了',
                    onClick: e => {
                        this.setState({alert: {show: false}});
                        callback && callback()
                    }
                }]
            }
        })
    }

    showUnBindPhone() {
        this.setState({
            alert: {
                text: '根据国家相关法规，需要绑定手机号才可继续讲课，是否继续',
                title: '未绑定手机号',
                show: true,
                buttons: [{
                    label: '立刻绑定',
                    onClick: () => {
                        this.setState({alert: {show: false}});
                        location.assign('/management/bind-cell-phone?redirect_url='
                            + encodeURIComponent(location.href))
                    }
                }]
            }
        })
    }

    showFengKongTip(){
        /*
        * 风控弹窗
        * 2020年5月25日0:00开始，2020年6月4日24:00结束
        */
        const riskNational = localStorage.getItem('UserConfig/RiskNational2')
        const now = new Date().getTime()

        const start_time = new Date(2020,4,25).getTime()
        const end_time = new Date(2020,5,5).getTime()
        if(riskNational) {
            return null
        }
        if(now < start_time || now > end_time) {
            return null
        }
        this.setState({
            alert: {
                text: <pre style={{ textAlign: 'center', whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>
                  <div>尊敬的用户您好，由于系统升级维护，6月4日凌晨0点至24点，平台将暂时无法进行开课、创课、上传课件、分享、编辑等操作，6月5日所有功能恢复正常使用状态。非常抱歉给您造成不便，如有疑问，请联系公众号客服咨询。</div>
                </pre>,
                show: true,
                buttons: [{
                    label: '确定',
                    onClick: () => {
                        this.setState({ alert: { show: false } })
                        localStorage.setItem('UserConfig/RiskNational2', 1)
                    }
                }]
            }
        })
    }

    showConfirm(title, text, callback, cancelCallBack, cancelText, confirmText) {
        let that = this;
        this.setState({
            confirm: {
                text: text,
                title: title,
                show: true,
                buttons: [{
                    type: 'default',
                    label: cancelText || '取消',
                    onClick: cancelCallBack || function() {that.setState({confirm: {show: false}})}
                },{
                    type: 'primary',
                    label: confirmText || '确定',
                    onClick: e => {
                        that.setState({confirm: {show: false}});
                        callback && callback()
                    }
                }]
            }
        })
    }

    showMenu(menus) {
        this.setState({showOperateMenu: true, operateMenus: menus})
    }

    hideMenu() {
        this.setState({showOperateMenu: false})
    }

    render() {
        const {error} = this.props
        if(error.showError){
            return <div className="wk-inner-page">
                    <div className="error-container wk-center">
                        <div className="error-container-pic">
                            <img src={error.img} alt=""/>
                        </div>
                        <div className="error-container-text">{error.tips}</div>
                        <a href={error.href} className="weui-btn_mini weui-btn weui-btn_plain-primary wk-back-to-index">
                            {error.btn}
                        </a>
                    </div>
                </div>
        }

        return (
            <div className={`page ${this.props.className || ''}`}>
                <div className="page-actionsheet-container">
                    <ActionSheet
                        menus={this.state.operateMenus}
                        actions={[{
                            label: '取消',
                            onClick: this.hideMenu.bind(this)
                        }]}
                        show={this.state.showOperateMenu}
                        onRequestClose={this.hideMenu.bind(this)}
                    />
                </div>
                <Toast icon={this.state.toastIcon} show={this.state.showToast}>
                    {this.state.toastText}
                </Toast>
                <Toptips type={this.state.tipsType} show={this.state.showTips}>
                    {this.state.tipsText}
                </Toptips>
                <Dialog type="ios" title={this.state.alert.title}
                        buttons={this.state.alert.buttons}
                        show={this.state.alert.show}
                        className="page-alert">
                    {this.state.alert.text}
                </Dialog>
                <Dialog type="ios" title={this.state.confirm.title}
                        buttons={this.state.confirm.buttons}
                        show={this.state.confirm.show}>
                    {this.state.confirm.text}
                </Dialog>
                {this.props.children}
            </div>
        );
    }
}


Page.childContextTypes = {
    page: React.PropTypes.object
};


export default connect((state) => ({
    showInvitationCard: state.wechat.showInvitationCard,
    error: state.error,
}))(Page);




// WEBPACK FOOTER //
// ./src/components/Page.js